import { render, staticRenderFns } from "./Pio.vue?vue&type=template&id=11b166f0&"
import script from "./Pio.vue?vue&type=script&lang=js&"
export * from "./Pio.vue?vue&type=script&lang=js&"
import style0 from "./Pio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports